/**
 * Created by user on 2020/6/9.
 */

export const SymGlobTree = Symbol.for('@lazy-glob/sort-tree');

export default {
  SymGlobTree,
};
